import dayjs from 'dayjs';
import { TimePeriod, Period } from '@/types/date';
import { SelectItem } from '@/types/ui';
import { QUARTER_IN_MONTH, formatPeriod, getPeriodUntilDate } from '@/utils/date';

export const getComparisonPeriodOptions = (): SelectItem<Period>[] => [
  {
    label: 'Previous week',
    value: getPeriodUntilDate(dayjs().subtract(1, 'week'), TimePeriod.WEEK),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs().subtract(1, 'week'), TimePeriod.WEEK)),
  },
  {
    label: 'Previous month',
    value: getPeriodUntilDate(dayjs().subtract(1, 'month'), TimePeriod.MONTH),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs().subtract(1, 'month'), TimePeriod.MONTH)),
  },
  {
    label: 'Previous quarter',
    value: getPeriodUntilDate(dayjs().subtract(QUARTER_IN_MONTH, 'month'), TimePeriod.QUARTER),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs().subtract(QUARTER_IN_MONTH, 'month'), TimePeriod.QUARTER)),
  },
  {
    label: 'Previous YTD',
    value: getPeriodUntilDate(dayjs().subtract(1, 'year'), TimePeriod.YTD),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs().subtract(1, 'year'), TimePeriod.YTD)),
  },
  {
    label: 'Previous year',
    value: getPeriodUntilDate(dayjs().subtract(1, 'year'), TimePeriod.YEAR),
    additionalInfo: formatPeriod(getPeriodUntilDate(dayjs().subtract(1, 'year'), TimePeriod.YEAR)),
  },
  {
    label: 'Custom',
    value: getPeriodUntilDate(dayjs(), TimePeriod.CUSTOM),
    additionalInfo: 'Choose your dates',
  },
];

export default getComparisonPeriodOptions;
